module.exports = __webpack_public_path__ + "media/images/drop-icon-inactive-1a95a7a841074472490be6b007735f8a.svg";